import { render, staticRenderFns } from "./FrequencyGraph.vue?vue&type=template&id=3ec01304&"
import script from "./FrequencyGraph.vue?vue&type=script&lang=js&"
export * from "./FrequencyGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports